/**
 * i18next Configuration
 *
 * Bundled translations approach (no HTTP backend)
 * - Faster initial load
 * - No additional network requests
 * - ~15KB total for all translations
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  LANGUAGE_STORAGE_KEY,
  NAMESPACES,
  DEFAULT_NAMESPACE,
} from './config';

// Import translations directly (bundled)
import esCommon from './locales/es/common.json';
import esApp from './locales/es/app.json';
import esLanding from './locales/es/landing.json';
import esAuth from './locales/es/auth.json';
import esLegal from './locales/es/legal.json';

import enCommon from './locales/en/common.json';
import enApp from './locales/en/app.json';
import enLanding from './locales/en/landing.json';
import enAuth from './locales/en/auth.json';
import enLegal from './locales/en/legal.json';

const resources = {
  es: {
    common: esCommon,
    app: esApp,
    landing: esLanding,
    auth: esAuth,
    legal: esLegal,
  },
  en: {
    common: enCommon,
    app: enApp,
    landing: enLanding,
    auth: enAuth,
    legal: enLegal,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    defaultNS: DEFAULT_NAMESPACE,
    ns: NAMESPACES,

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false, // Not needed with bundled translations
    },

    // Debug mode in development
    debug: process.env.NODE_ENV === 'development',
  });

// Set document language on init
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language;
}

// Update document language when language changes
i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});

export default i18n;
